// Función helper para construir headers unificados sin forzar datos
const buildHeaders = (contentType = null) => {
    const token = 'Bearer ' + localStorage.getItem('AccessToken');
    const headers = {
        'Accept': 'application/json',
        'Authorization': token,
    };

    if (contentType) {
        headers['Content-Type'] = contentType;
    }

    let merchantUuid = localStorage.getItem('work_mode_merchant_uuid');
    
    // Si no hay workspace, usamos la Entidad principal del login como salvavidas
    if (!merchantUuid) {
        const entityData = localStorage.getItem('Entity');
        if (entityData) {
            merchantUuid = JSON.parse(entityData).uuid; // O el campo de ID que uses
        }
    }

    if (merchantUuid) {
        headers['X-Workspace-Merchant'] = merchantUuid;
    }

    return headers;
};


export async function GET(ruta)
{
    try
    {
        let response = await fetch(
            ruta,
            {
                method : 'GET',
                headers: buildHeaders()
            }
        );

        let responseJson = await response.json();
        console.log(responseJson);

        return responseJson;

        /*if(responseJson.success === true )
        {
            return responseJson;
        }

        if(responseJson.success === false)
        {
            return responseJson.message;
        }*/

    }
    catch(error)
    {
        return error;
    }
}


export async function POST(ruta,parametros,type=undefined)
{
    try 
    {

        let params = new FormData();
        parametros.map((p)=>{
            params.append(p.name,p.value);
        });
        
        let response = await fetch(
            ruta,
            {
                method : 'POST',
                headers: buildHeaders(),
                body : params
            }
        );

        let responseJson = await response.json();

        return responseJson;
        
    } 
    catch (error) 
    {
        return error;
    }
}


export async function POST_JSON(ruta,parametros)
{
    try 
    {
        let response = await fetch(
            ruta,
            {
                method : 'POST',
                headers: buildHeaders('application/json'),
                body : JSON.stringify(parametros)
            }
        );
            
        let responseJson = await response.json();

        return responseJson;
        
    } 
    catch (error) 
    {
        return error;
    }
}


//Nueva version
async function apiFetch(ruta, method = 'GET', body = null) {
    try {
        const token = 'Bearer ' + localStorage.getItem('AccessToken');
        
        const headers = {
            'Accept': 'application/json',
            //'Content-Type' : 'application/json',
            'Authorization': token,
        };

        let merchantUuid = localStorage.getItem('work_mode_merchant_uuid');
    
        // Si no hay workspace, usamos la Entidad principal del login como salvavidas
        if (!merchantUuid) {
            const entityData = localStorage.getItem('Entity');
            if (entityData) {
                merchantUuid = JSON.parse(entityData).uuid; // O el campo de ID que uses
            }
        }

        if (merchantUuid) {
            headers['X-Workspace-Merchant'] = merchantUuid;
        }
        

        const options = { method, headers };

        if (body) {
            options.body = JSON.stringify(body);
            headers['Content-Type'] = 'application/json';
        }

        const response = await fetch(ruta, options);

        // Siempre esperamos una respuesta JSON gracias al BaseController.
        return await response.json();

    } catch (error) {
        // Manejo de errores de red o JSON inválido
        console.error('API Fetch Error:', error);
        return { success: false, message: 'Error de conexión o respuesta inválida.' };
    }
}




export const api = {
    get: (ruta) => apiFetch(ruta, 'GET'),
    post: (ruta, body) => apiFetch(ruta, 'POST', body),
    put: (ruta, body) => apiFetch(ruta, 'PUT', body),
    delete: (ruta) => apiFetch(ruta, 'DELETE'),
};

// Exportaciones
/*export const GET_JSON = (ruta) => apiFetch(ruta, 'GET');
export const POST_JSON = (ruta, body) => apiFetch(ruta, 'POST', body);
export const PUT_JSON = (ruta, body) => apiFetch(ruta, 'PUT', body);
export const DELETE_JSON = (ruta) => apiFetch(ruta, 'DELETE');*/

